import React from "react";

import {
  Link,
} from "react-router-dom";

import {
  FaPlusCircle,
  FaChevronRight,
} from "react-icons/fa";

import Footer from "../components/Footer";

import transporte from "../images/transporte.png";
import localidad from "../images/tucuman.png";
import precio from "../images/DANLU_logo_transparent.png";
import camion from "../images/camion.png";
import estacion from "../images/estacion.png";
import estado from "../images/estado.png";
import destino from "../images/destino.png";
import producto from "../images/papas.png";
import cliente from "../images/cliente.jpg";
import chofer from "../images/chofer.jpg";
import proveedor from "../images/proveedores.jpg";
import egreso from "../images/egreso.png";
import cuota from "../images/cuota.jpg";
import empleado from "../images/empleado.jpg";

import "../css/home.css";
import "../css/footer.css";

const items = [
  {
    to: "/clientes",
    img: cliente,
    titulo: "Clientes",
    descripcion:
      "Alta y administración de clientes",
  },
  {
    to: "/Proveedores",
    img: proveedor,
    titulo: "Proveedores",
    descripcion:
      "Gestión de proveedores",
  },
  {
    to: "/empleados",
    img: empleado,
    titulo: "Empleados",
    descripcion:
      "Personal y usuarios operativos",
  },
  {
    to: "/localidades",
    img: localidad,
    titulo: "Localidades",
    descripcion:
      "Localidades y zonas de operación",
  },
  {
    to: "/productos",
    img: producto,
    titulo: "Productos",
    descripcion:
      "Productos transportados",
  },
  {
    to: "/estados",
    img: estado,
    titulo: "Estados",
    descripcion:
      "Estados utilizados por el sistema",
  },
  {
    to: "/transportes",
    img: transporte,
    titulo: "Transportes",
    descripcion:
      "Empresas y servicios de transporte",
  },
  {
    to: "/empresas",
    img: precio,
    titulo: "Empresas",
    descripcion:
      "Datos generales de empresas",
  },
  {
    to: "/camiones",
    img: camion,
    titulo: "Camiones",
    descripcion:
      "Vehículos y unidades de transporte",
  },
  {
    to: "/destinos",
    img: destino,
    titulo: "Destinos",
    descripcion:
      "Destinos y puntos de entrega",
  },
  {
    to: "/choferes",
    img: chofer,
    titulo: "Choferes",
    descripcion:
      "Conductores y datos asociados",
  },
  {
    to: "/cuentagastos",
    img: egreso,
    titulo: "Cuentas de gasto",
    descripcion:
      "Clasificación de gastos",
  },
  {
    to: "/gastos",
    img: egreso,
    titulo: "Gastos",
    descripcion:
      "Tipos de gastos del sistema",
  },
  {
    to: "/metodos",
    img: cuota,
    titulo: "Métodos",
    descripcion:
      "Métodos y modalidades de operación",
  },
  {
    to: "/estaciones",
    img: estacion,
    titulo: "Estaciones de servicio",
    descripcion:
      "Proveedores de combustible",
  },
];

const HomeAltas = () => {
  return (
    <>
      <main className="danlu-menu-page">
        {/* CABECERA */}

        <section className="danlu-menu-hero altas">
          <div className="danlu-menu-hero-icon">
            <FaPlusCircle />
          </div>

          <div>
            <span className="danlu-menu-eyebrow">
              CONFIGURACIÓN
            </span>

            <h1>
              Gestión de Altas
            </h1>

            <p>
              Administración de maestros,
              vehículos, personas y parámetros
              generales del sistema
            </p>
          </div>
        </section>

        {/* TÍTULO SECCIÓN */}

        <div className="danlu-menu-section-title">
          <div>
            <h2>
              Datos maestros
            </h2>

            <p>
              Seleccioná el módulo que querés administrar
            </p>
          </div>

          <span>
            {items.length} módulos
          </span>
        </div>

        {/* GRID */}

        <section className="danlu-management-grid">
          {items.map(
            ({
              to,
              img,
              titulo,
              descripcion,
            }) => (
              <Link
                to={to}
                key={to}
                className="danlu-management-card"
              >
                <div className="danlu-management-icon">
                  <img
                    src={img}
                    alt={titulo}
                  />
                </div>

                <div className="danlu-management-body">
                  <h3>
                    {titulo}
                  </h3>

                  <p>
                    {descripcion}
                  </p>
                </div>

                <div className="danlu-management-arrow">
                  <FaChevronRight />
                </div>
              </Link>
            )
          )}
        </section>
      </main>

      <Footer />
    </>
  );
};

export default HomeAltas;